const isDevelopment = process.env.NODE_ENV === "development";

const getEnv = (name: string, fallback: string) =>
  process.env[name] && process.env[name]?.trim()
    ? (process.env[name] as string)
    : fallback;

export const siteVariant = getEnv("REACT_APP_SITE_VARIANT", "slteach");
export const siteName = getEnv("REACT_APP_SITE_NAME", "SL TEACH");
export const siteTitle = getEnv(
  "REACT_APP_SITE_TITLE",
  "SL Teach E-Learning System",
);
export const siteMetaDescription = getEnv(
  "REACT_APP_SITE_META_DESCRIPTION",
  "SL Teach E-Learning System",
);
export const siteTagline = getEnv(
  "REACT_APP_SITE_TAGLINE",
  "Online Classes",
);
export const brandIconColor = getEnv("REACT_APP_BRAND_ICON_COLOR", "#ED8936");
export const brandTextColor = getEnv("REACT_APP_BRAND_TEXT_COLOR", "#DD6B20");
export const sidebarAccentColor = getEnv(
  "REACT_APP_SIDEBAR_ACCENT_COLOR",
  "#63B3ED",
);
export const cookieDomain = getEnv(
  "REACT_APP_COOKIE_DOMAIN",
  ".app.slteach.com",
);
export const supportWebsiteUrl = getEnv(
  "REACT_APP_SUPPORT_WEBSITE_URL",
  "https://slteach.com",
);
export const supportWhatsAppNumber = getEnv(
  "REACT_APP_SUPPORT_WHATSAPP_NUMBER",
  "+393667216042",
);
export const supportWhatsAppText = getEnv(
  "REACT_APP_SUPPORT_WHATSAPP_TEXT",
  "Hello",
);
export const appAccessEmailDomain = getEnv(
  "REACT_APP_APP_ACCESS_EMAIL_DOMAIN",
  "slteach.com",
);

export const cloudApi = getEnv(
  "REACT_APP_API_URL",
  "https://api.app.slteach.com",
);
export const cloudMobileApi = getEnv(
  "REACT_APP_MOBILE_API_URL",
  "https://api.la.devsquadx-cloud.com",
);

export const frontendLink = isDevelopment
  ? getEnv("REACT_APP_DEV_FRONTEND_URL", "http://localhost:3000")
  : getEnv("REACT_APP_FRONTEND_URL", "https://app.slteach.com");

export const api = isDevelopment
  ? getEnv("REACT_APP_DEV_API_URL", "http://localhost:1337")
  : cloudApi;

export const UploadApi = isDevelopment
  ? getEnv(
      "REACT_APP_DEV_UPLOAD_API_URL",
      "https://659b-112-134-225-174.ngrok-free.app",
    )
  : getEnv("REACT_APP_UPLOAD_API_URL", cloudApi);

export const mobileApi = isDevelopment
  ? getEnv("REACT_APP_DEV_MOBILE_API_URL", "http://localhost:1338")
  : cloudMobileApi;

export const recaptchaKey = isDevelopment
  ? getEnv(
      "REACT_APP_DEV_RECAPTCHA_KEY",
      "6Lcn6OsbAAAAAENInrkvkXTd_EKaB7g5j_wwTKAG",
    )
  : getEnv(
      "REACT_APP_RECAPTCHA_KEY",
      "6LdXXnAfAAAAAF9Z1PDkb1CGM1iHZo0cZ6-ayvZf",
    );

export const stripePublishableKey = isDevelopment
  ? getEnv(
      "REACT_APP_DEV_STRIPE_PUBLISHABLE_KEY",
      "pk_test_51KsIJOHAoYbhjd1tmE85JyuBNCDjHzCuXKfwzsul9PaEAn6je1EUSFwvsFzcaJR6b4BsZtF4qbeqH5X6xrSkKw6400vkBHkKB5",
    )
  : getEnv(
      "REACT_APP_STRIPE_PUBLISHABLE_KEY",
      "pk_live_51Qnh1fECLwbKdKrBpDvPJtvsYxYhAZ8NMicp5gvfNLlZ7EqpyFVpdzsNs8Xxsvu2bsawCidwnBla22Wp2JwRYvwx00yGJoCQAG",
    );

export const apiLink = isDevelopment ? api : cloudApi;

export const payhereMerchantId = isDevelopment
  ? getEnv("REACT_APP_DEV_PAYHERE_MERCHANT_ID", "1221928")
  : getEnv("REACT_APP_PAYHERE_MERCHANT_ID", "219073");

export const apiPayhere = isDevelopment
  ? getEnv(
      "REACT_APP_DEV_PAYHERE_API_URL",
      "https://b788-2402-4000-21c0-638c-b05f-e0db-df71-56ee.ngrok-free.app",
    )
  : getEnv("REACT_APP_PAYHERE_API_URL", api);
